import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronDown, Tv2, Youtube, Terminal, Settings } from 'lucide-react'
import { TwitchBotPanel } from './TwitchBotPanel'
import { YoutubeBotPanel } from './YoutubeBotPanel'
import { CommandsReference } from './CommandsReference'
import { BotSettingsPanel } from './BotSettingsPanel'

function CollapsibleCard({
  title,
  icon: Icon,
  iconColor,
  children,
  defaultOpen = false,
}: {
  title: string
  icon: React.ElementType
  iconColor?: string
  children: React.ReactNode
  defaultOpen?: boolean
}) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="border border-border rounded-xl overflow-hidden flex-1">
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="w-full flex items-center justify-between px-5 py-3 bg-card hover:bg-muted/50 transition-colors text-left"
      >
        <div className="flex items-center gap-2">
          <Icon className={`w-4 h-4 ${iconColor || ''}`} />
          <span className="font-medium text-sm">{title}</span>
        </div>
        <ChevronDown
          className={`w-4 h-4 text-muted-foreground transition-transform ${open ? '' : '-rotate-90'}`}
        />
      </button>
      {open && <div className="px-5 py-4 border-t border-border bg-background">{children}</div>}
    </div>
  )
}

export function BotPanelSection() {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <div className="flex flex-col lg:flex-row gap-4">
        <CollapsibleCard
          title={t('admin.live_bot_panel_title')}
          icon={Tv2}
          iconColor="text-[#9146FF]"
        >
          <TwitchBotPanel />
        </CollapsibleCard>

        <CollapsibleCard title="YouTube Bot" icon={Youtube} iconColor="text-red-500">
          <YoutubeBotPanel />
        </CollapsibleCard>
      </div>

      <div className="flex flex-col lg:flex-row gap-4">
        <CollapsibleCard title="Bot Settings" icon={Settings} defaultOpen>
          <BotSettingsPanel />
        </CollapsibleCard>

        <CollapsibleCard title="Bot Commands" icon={Terminal}>
          <CommandsReference />
        </CollapsibleCard>
      </div>
    </div>
  )
}
